import { render } from "./Chat.vue?vue&type=template&id=775eedd9&bindings={\"state\":\"setup\",\"addMessage\":\"setup\",\"userId\":\"setup\"}"
import script from "./Chat.vue?vue&type=script&lang=js"
export * from "./Chat.vue?vue&type=script&lang=js"
script.render = render

export default script